/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartViewTeleconsultationRecordAliases {
  IMAGE_CHAT = 'image-chat',
  LAYOUT_VIEW_TELEHEALTH_RECORD = 'layout-view-telehealth-record',
  LOADER_CONTENT = 'loader-content',
  PANEL_CHAT = 'panel-chat',
  PANEL_LOADER = 'panel-loader',
  PANEL_PDF_VIEWER_CHAT = 'panel-pdf-viewer-chat',
  PANEL_REPORT = 'panel-report',
  PANEL_VIDEOSTREAM = 'panel-videostream',
  PDF_VIEWER_CHAT = 'pdf-viewer-chat',
  VIDEO_STREAM_CONSULTATION = 'video-stream-consultation',
}
export { MyChartViewTeleconsultationRecordAliases };
